module.exports = __webpack_public_path__ + "static/media/airflow.3bda18de.svg";